import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Slider } from '@atlas/components';
import {
  getPromotionsList,
  SiteConfigManager,
  useApplicationState,
  useSettings,
} from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { ChipsItem, Icon, Label } from '@atlas/ui';

import { BASE_PATH } from 'src/common/constants';
import { PromotionsCard } from 'components/Promotion';
import { CDN_TYPE_CMS, imageUrlCDN } from 'src/common/utils';

const LobbyPromotionsBlock = ({ blockTitleKey, imageUrl }) => {
  const [swiper, setSwiper] = useState(null);
  const prevSlide = () => swiper && swiper.slidePrev();
  const nextSlide = () => swiper && swiper.slideNext();
  const [isShowImg, toggleVisibilityImg] = useState(true);
  const handleError = () => toggleVisibilityImg(false);

  const [isLocked, setIsLocked] = useState(false);

  const { authenticated } = useApplicationState();
  const { lang } = useSettings();
  const { push: navigate } = useHistory();
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);

  const promotionsPath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.PROMOTIONS);

  useEffect(() => {
    const userVisibilities = ['public', authenticated ? 'registered' : 'anonymous'];

    setLoading(true);
    getPromotionsList(userVisibilities)
      .then(promos => {
        const sorted = (promos || []).sort((a, b) => {
          const aOrder = a.order_position ?? 0;
          const bOrder = b.order_position ?? 0;
          return aOrder - bOrder;
        });
        setPromotions(sorted);
      })
      .catch(err => {
        console.error('Failed to load promotions', err);
        setPromotions([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [lang, authenticated]);

  if (loading || promotions.length === 0) {
    return null;
  }

  return (
    <div className="casino-lobby__item lobby-promotions">
      <div className="casino-lobby__header">
        <div className="casino-lobby__left">
          {isShowImg && (
            <div className="casino-lobby__icon">
              <img
                alt={blockTitleKey}
                height={32}
                onError={handleError}
                role="presentation"
                src={
                  imageUrl
                    ? `${encodeURI(imageUrlCDN(imageUrl, CDN_TYPE_CMS))}`
                    : `${BASE_PATH || ''}/static/assets/images/deposit-bonus.png`
                }
                width={32}
              />
            </div>
          )}
          {blockTitleKey && (
            <div className="casino-lobby__title">
              <Label message={blockTitleKey} />
            </div>
          )}
        </div>
        <div className="casino-lobby__right">
          <ChipsItem
            className="casino__category__view-all"
            label={
              <div className="casino__category__title__view">
                <Label className="casino__category__title__text" message="View_All" />
                <span>({loading ? '...' : promotions.length})</span>
              </div>
            }
            onClick={() => navigate(promotionsPath)}
          />

          {!isLocked && (
            <>
              <ChipsItem
                className="casino-lobby__arrow casino-lobby__arrow-left"
                label={<Icon name="arrow-left" />}
                onClick={prevSlide}
              />
              <ChipsItem
                className="casino-lobby__arrow casino-lobby__arrow-right"
                label={<Icon name="arrow-right" />}
                onClick={nextSlide}
              />
            </>
          )}
        </div>
      </div>

      <div className="casino-lobby__content">
        <div className="lobby-promotions__slider">
          <Slider
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            direction="horizontal"
            loop={false}
            onBeforeInit={setSwiper}
            onLock={() => setIsLocked(true)}
            onUnlock={() => setIsLocked(false)}
            onUpdate={swiperInstance => setIsLocked(swiperInstance.isLocked)}
            spaceBetween={14}
            speed={1000}
          >
            {promotions.map((item, index) => (
              <Slider.Slide key={loading ? `skeleton-${index}` : item.id}>
                <PromotionsCard buttonSize="small" promotion={item} />
              </Slider.Slide>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default LobbyPromotionsBlock;
